import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import CustomListComponent from '../../../components/base/CustomListComponent';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import ContentSections from '../../../components/base/ContentSections';
import { listItem, listImage, titleForItem } from '../../../components/banners/DisplayItems';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import {
  APIStatus,
  DISPLAY_CARD_BACKGROUND_TYPE,
} from '../../../config/CustomEnums';
import Loading from '../../../components/base/Loading';
import i18n from '../../../I18n';


function LevelDetail({
  detail,
  languages,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch({ type: 'levels/clearData' });
    dispatch({
      type: 'levels/getOneDetail',
      payload: {
        id: params.id,
      }
    });
    dispatch({
      type: 'language/getList',
      payload: {
        isSelectorLoad: true,
      }
    });
  }, [dispatch, params.id]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'levels/clearData' });
    };
  }, [dispatch]);

  const renderTabForLanguage = (language) => {
    return [
      <>
        <div className="first-section-title">
          {i18n.t('general', { locale: language })}
        </div>
        {listItem(
          i18n.t('name', { locale: language }),
          detail.translations?.[language]?.levelName
        )}
      </>,
      <>
        <div className="first-section-title">
          INFORMATION
        </div>
        {listItem('ID', detail.pk)}
        {listItem('Foreground element color (hex)', detail.foregroundElementColor)}
        {listItem('Background of membership card', DISPLAY_CARD_BACKGROUND_TYPE[detail.membershipCardBackgroundType])}
        {listItem('Background color (hex)', detail.membershipCardBackgroundColor)}
        {listImage('Background image for card in landscape (app)', detail.cardLandscapeBackgroundImageInApp)}
        {listImage('Background image for card in portrait (app)', detail.cardPortraitBackgroundImageInApp)}
        {listImage('Background image for card in landscape (website)', detail.cardLandscapeBackgroundImageInWeb)}
        {listImage('Background image for card in portrait (website)', detail.cardPortraitBackgroundImageInWeb)}
        {listItem('Hide level details & upgrade tips on membership card', detail.hideLevelDetailsAndUpgradeTips ? 'true' : 'false')}
        {listItem('Creation time', detail.detailDisplayCreationDate)}
        {listItem('Last modified time', detail.detailDisplayLastModifiedDate)}
        {listItem('Last modified by', detail.displayLastModifiedBy)}
      </>,
      <>
        <div className="first-section-title">
          ENTRY REQUIREMENT
        </div>
        {listItem('Is lowest level (level 1)', detail.isLowestLevel ? 'true' : 'false')}
        {listItem('Level rank', detail.levelRank)}
        {listItem('Entry requirements', detail.displayEntryRequirements)}
      </>,
      <>
        <div className="first-section-title">
          RENEWAL & DOWNGRADE SETTINGS
        </div>
        {listItem('Renewal logic', detail.displayRenewalLogic)}
        {listItem('Retain requirements', detail.displayRetainRequirements)}
        {listItem('Downgrade logic', detail.displayDowngradeLogic)}
        {listItem('Downgrade to', detail.displayDowngradeLevel)}
        {listItem('Minimum downgrade level', detail.displayMinimumDowngradeLevel)}
      </>
    ]
  };

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            languageTabContent={{
              containers: languages?.map((item) => ({
                container: renderTabForLanguage(item.code),
                key: item.code,
                title: item.sourceName,
              })),
            }}
            hidePreview={true}
          />
        </div>
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title="Edit"
      action={() => history.push('edit/')}
      requires={PermissionCodes.changeLevel}
    />
  ];

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: detail?.levelName || '',
        }}
        breadcrumb={
          <CustomBreadcrumb name={detail?.levelName ? `${detail.levelName}` : ''} />
        }
        hideTab={true}
        tabs={tabs}
        buttons={buttons}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  detail: state.levels.detail,
  languages: state.language.allList,
});

export default connect(mapPropsToState)(LevelDetail);
